export const TitleSpan = ({ className, children }: { className?: string, children: React.ReactNode }) =>
  <span className={`text-[10px] font-bold text-muted-foreground uppercase tracking-wider ${className}`}>{children}</span>